import API from './request'; // 加载平台接口封装
export const commonApi = {
  // 获取客户数据
  getCustomerData: (params) => API.post(`/customer/calibration/batch/query`, params),
  // 获取客户单位的CRM建议
  getCrmSuggestions: (params) => API.post(`/customer/calibration/unit/crmSuggestions`, params),
  // 获取天眼查建议
  getTycSuggestions: (params) => API.post(`/customer/calibration/unit/tycSuggestions`, params),
  // 更新并重新校准客户
  updateAndRematch: (params) => API.post(`/customer/calibration/unit/updateAndRematch`, params),
  // 确认批次
  confirmBatch: (params) => API.post(`/customer/calibration/batch/${params.batchId}/confirm`),
  // 导出批次
  exportBatch: (params) => API.post(`/customer/calibration/batch/export`, params, {
    headers: {
      download: true // 局部覆盖
    },
    responseType: 'arraybuffer'
  }),
  // 确认审核
  confirmCheck: (params) => API.post(`/customer/calibration/batch/${params.batchId}/confirmCheck`, params)
};
